export const persistConstants = {
  blacklistedKeys: [
    "columns",
    "datagridRows",
    "dependedRelation",
    "error",
    "filtering",
    "form",
    "configuration",
    "loading",
    "masterDetail",
  ],
};
